import { updateCollectionPageLinksByRouterConfig } from '@wix/ambassador-data-collection-page-links-v1-collection-page-links/http'
import type { PageData, RouterPage } from '@wix/editor-platform-sdk-types'
import type { HttpClient } from '@wix/http-client'
import type {
  DynamicPageRouterData,
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import { keyBy, mapValues } from 'lodash'
import { runWithRetry } from '../../infra/runWithRetry'
import { findPageIdByPageRole } from './router-config'

type PageId = string
type PageRole = string

const mapPageRolesToPageIds = (pages: RouterPage[]): Record<PageRole, PageId> =>
  mapValues(
    keyBy(pages, page => page.pageRoles[0]),
    page => page.pageRef.id,
  )

type EnrichedRouter = Omit<DynamicPageRouterData, 'pages' | 'config'> & {
  pages: Record<PageRole, PageId>
  config: RouterConfig
}

const enrichRoutesWithPageLinkDisplayName = (
  router: DynamicPageRouterData,
  pagesById: Record<PageId, PageData>,
): EnrichedRouter => ({
  ...router,
  pages: mapPageRolesToPageIds(router.pages),
  config: {
    ...router.config,
    patterns: mapValues(router.config.patterns, patternDefinition => {
      const pageId = findPageIdByPageRole(router, patternDefinition.pageRole)!

      return {
        ...patternDefinition,
        config: {
          ...patternDefinition.config,
          pageLinkDisplayName: pagesById[pageId].title,
        },
      }
    }),
  },
})

const TRY_COUNT = 2

export const syncRouters = async ({
  routers,
  editorSdkProxy,
  httpClient,
}: {
  routers: DynamicPageRouterData[]
  editorSdkProxy: EditorSDK
  httpClient: HttpClient
}) => {
  const pages = await editorSdkProxy.pages.getApplicationPages({
    includeUnmanaged: false,
  })

  const pagesById = keyBy(pages, 'id')

  const routersWithPageLinkName = routers.map(router =>
    enrichRoutesWithPageLinkDisplayName(router, pagesById),
  )

  await runWithRetry(
    () =>
      httpClient.request(
        updateCollectionPageLinksByRouterConfig({
          routers: routersWithPageLinkName,
        }),
      ),
    TRY_COUNT,
  )
}
